import { StyleSheet, TextStyle, ViewStyle } from 'react-native';
import { MODIFIER_STYLE_COLOURS } from './modifierStyleTypes';

// Predefined text/swatch styles keyed by each palette hex, so components can
// select a StyleSheet entry by colour instead of allocating an inline style
// object per render. Keys are uppercased (the validator accepts colours
// case-insensitively) so a persisted lowercase hex still resolves.
const textEntries: Record<string, TextStyle> = {};
const swatchEntries: Record<string, ViewStyle> = {};
MODIFIER_STYLE_COLOURS.forEach(({ color }) => {
  textEntries[color.toUpperCase()] = { color };
  swatchEntries[color.toUpperCase()] = { backgroundColor: color };
});

export const modifierTextColorStyles = StyleSheet.create(textEntries);
export const modifierSwatchColorStyles = StyleSheet.create(swatchEntries);

/** Returns the text style for a palette colour, case-insensitively. */
export function modifierTextColorStyle(
  color: string | undefined,
): TextStyle | undefined {
  return color ? modifierTextColorStyles[color.toUpperCase()] : undefined;
}

/** Returns the swatch style for a palette colour, case-insensitively. */
export function modifierSwatchColorStyle(
  color: string | undefined,
): ViewStyle | undefined {
  return color ? modifierSwatchColorStyles[color.toUpperCase()] : undefined;
}
